module.exports = __webpack_public_path__ + "img/Group 136.2a98e7ad.svg";